import { SiteInfo } from "../types";
import { onImportFonts } from "./localhost";

const { indexedPaths } = require("../seo.ts");

const domainName = "onlineqrcode.com";
const theme = "kalimotxo";

import { fonts } from "@/themes/kalimotxo/fonts/fonts";

export const onlineQrCode: SiteInfo = {
  domainName: domainName,
  siteName: "onlineQRcode",
  siteTheme: theme,
  isFreeTrial: false,
  siteEmail: `info@${domainName}`,
  siteWhiteLogo: "/svg/logoFooter.svg",
  siteBlackLogo32: "/svg/logo32.svg",
  siteBlackLogo28: "/svg/logo28.svg",
  siteLogoMobile: "/svg/logo-mobile.svg",
  siteBlackLogoFooter: "/svg/logoFooter.svg",
  favicon: "/images/favicon-default.png",
  indexedPaths: indexedPaths[domainName],
  companies: ["ebdaniTradeSL", "globalOpServicesLLC", "onworldDigitalCorporationSL"],
  fonts: onImportFonts(fonts),
};
